import { ShoppingBag, Tag, Star, ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react'
import { fmtEuroInt } from '../lib/format'

const LILA_BORDER = 'color-mix(in srgb, var(--accent-troedel) 30%, transparent)'

// Wachstumsrate (letzte 30 Tage vs. Tag 31–60). pct === null → "Neu" (neuer Bereich
// ODER unsichere Datenlage; via storeData.growthReason intern unterscheidbar).
function GrowthBadge({ pct }) {
  if (pct == null) {
    return <div className="text-[10px] text-[var(--label-tertiary)]">Neu</div>
  }
  if (pct === 0) {
    return (
      <div className="flex items-center justify-end gap-0.5 text-[10px]" style={{ color: 'var(--label-tertiary)' }}>
        <Minus size={11} />0 %
      </div>
    )
  }
  const up = pct > 0
  const Icon = up ? ArrowUpRight : ArrowDownRight
  return (
    <div className="flex items-center justify-end gap-0.5 text-[10px] font-medium" style={{ color: up ? 'var(--accent-stand)' : 'var(--accent-red)' }}>
      <Icon size={11} />{up ? '+' : '−'}{Math.abs(pct)} %
    </div>
  )
}

// Helfer-Glow: sehr dezenter Channel-Tint-Border, spürbar schwächer als der
// Live-Border (30%) — markiert "du hilfst hier" ohne aufzudrängen.
const HELPER_BORDER = (accentVar) => `color-mix(in srgb, ${accentVar} 14%, transparent)`

export function BereichCard({ store, storeData, onClick, isFavorite, onToggleFavorite }) {
  const isOnline = store.type === 'online'
  const accent = isOnline ? 'var(--accent-online)' : 'var(--accent-troedel)'
  const tint = isOnline ? 'var(--tint-online)' : 'var(--tint-troedel)'
  const Icon = isOnline ? ShoppingBag : Tag
  const isHelper = store.role === 'fulfillment'

  const isLive = !!storeData?.liveSession
  const openCount = storeData?.openOrdersCount ?? 0
  const revenue = storeData?.totalRevenue ?? 0

  // Subtitle: live > offene Bestellungen > nur Channel.
  let subtitle = isOnline ? 'Online-Store' : 'Trödel'
  if (isLive) subtitle = 'Trödel · live'
  else if (isOnline && openCount > 0) subtitle = `Online-Store · ${openCount} offen`

  // Rechter Wert: live zeigt Heute-Umsatz, sonst Gesamt.
  const showLiveValue = isLive
  const showTotal = !isLive && revenue > 0

  return (
    <div
      onClick={onClick}
      data-testid={`area-card-${store.type}`}
      className="bg-[var(--bg-L1)] border rounded-[20px] p-3 mb-2 flex items-center gap-2.5 cursor-pointer active:scale-[0.99] transition-transform"
      style={{ borderColor: isLive ? LILA_BORDER : (isHelper ? HELPER_BORDER(accent) : 'var(--border-subtle)') }}
    >
      <div
        className="w-[38px] h-[38px] rounded-lg flex items-center justify-center flex-shrink-0"
        style={{ background: tint }}
      >
        <Icon size={18} style={{ color: accent }} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[15px] font-medium flex items-center gap-1.5 min-w-0">
          {isLive && <span className="bl-pulse" style={{ width: 7, height: 7, background: 'var(--accent-stand)' }} />}
          <span className="truncate">{store.name}</span>
          {isHelper && (
            <span
              className="flex-shrink-0 text-[10px] font-medium px-1.5 py-0.5 rounded-[6px] whitespace-nowrap"
              style={{ background: 'var(--fill-tertiary)', color: 'var(--label-secondary)' }}
            >
              Du hilfst hier
            </span>
          )}
        </div>
        <div data-testid={`channel-pill-${store.type}`} className="text-[12.5px] font-medium mt-px truncate" style={{ color: accent }}>
          {subtitle}
        </div>
      </div>
      {showLiveValue && (
        <div className="text-right flex-shrink-0">
          <div className="text-base font-medium">{fmtEuroInt(storeData.liveSession.todayRevenue)}</div>
          <div className="text-[10px] text-[var(--label-tertiary)]">heute</div>
        </div>
      )}
      {showTotal && (
        <div className="text-right flex-shrink-0">
          <div className="text-base font-medium">{fmtEuroInt(revenue)}</div>
          <GrowthBadge pct={storeData?.growthPct} />
        </div>
      )}
      {onToggleFavorite && (
        <button
          onClick={(e) => { e.stopPropagation(); onToggleFavorite(store.id) }}
          className="-mr-1 flex-shrink-0 w-11 h-11 flex items-center justify-center active:scale-90 transition-transform"
          aria-label={isFavorite ? 'Favorit entfernen' : 'Als Favorit markieren'}
        >
          <Star
            size={18}
            fill={isFavorite ? 'var(--accent-yellow)' : 'none'}
            style={{ color: isFavorite ? 'var(--accent-yellow)' : 'var(--label-tertiary)' }}
          />
        </button>
      )}
    </div>
  )
}
